// extracted by mini-css-extract-plugin
export default {"inputField":"codeverifyPass_Acc_inputField__bB3Bt","btn":"codeverifyPass_Acc_btn__N1wFC","header":"codeverifyPass_Acc_header__cP8HE"};